import { TransactionTypeKey } from '@helios/common-api'
import {
  CounterParty,
  InventoryTypeKey,
} from '@helios/create-transactions-modal'
import { composeFieldPath } from '@northfork/basics'

export type Validations = Record<string, TransactionValidation[]>

export enum LinkedStatus {
  MATCHED = 'MATCHED',
  CUSTODY_MATCHED = 'CUSTODY_MATCHED',
  TRADING_MATCHED = 'TRADING_MATCHED',
  UNMATCHED = 'UNMATCHED',
}

export enum TransactionMatching {
  all = 'All',
  custody = 'Custody',
  trading = 'Trading',
}

export interface TransactionValidation {
  validationId: string
  message: string
}

export const transactionField = composeFieldPath(
  [] as BulkClearwaterTransaction[],
)

/**
 *
 */
export function getUniqueRowId({ id, accountId }: BulkClearwaterTransaction) {
  return `${id}-${accountId}`
}

export interface BulkClearwaterTransaction {
  clientLotId?: string | null
  transferPrice?: number
  transactionId: string
  revisionId: number
  id: number
  originalId: number
  active: boolean
  createdDate: string
  modifiedDate: string
  userId: number
  sourceId: number
  accountId: number
  sourceAccountId?: number
  sourceClearedDate?: string
  destAccountId?: number
  destClearedDate?: string
  securityId: number
  searchByIdIndex?: number
  basis?: string
  entryDate?: string
  settleDate?: string
  postDate?: string
  clearedDate?: string
  commission?: number
  originationFee?: number
  exitFee?: number
  exitFeeReceivable?: number
  drawFee?: number
  prepaymentPenaltyFee?: number
  delinquencyFee?: number
  modificationFee?: number
  miscellaneousFee?: number
  prepaidInterest?: number
  interestDue?: number
  factor?: number
  inventoryType?: InventoryTypeKey
  accrued?: number
  yield?: number
  counterPartyId?: number
  counterParty?: CounterParty
  price?: number
  valuationDate?: string
  traderId?: number
  amortOverrideType?: string
  fromSecurityId?: string
  toSecurityId?: string
  fromUnits?: string
  toUnits?: string
  sellToBuyRate?: string
  type: TransactionTypeKey
  amount: number
  units?: number
  currency: string
  custodyLinkedStatus: boolean
  isLibTransaction?: boolean
  linkedStatus: LinkedStatus
  tradingLinkedStatus: boolean
  secTypeCode: string
  tranTypeCode: string
  dataMap: Record<string, unknown>
  availableActions: BulkCwTranUpdateActionType[]
  tranData: Omit<BulkClearwaterTransaction, 'tranData'>
  validations?: Validations
  category: string
  typeLabelId?: string
  isEdited: boolean
  secIdentifier: string
  fromSecIdentifier?: string
  tranNote?: string
  isCapitalize?: boolean
}

export type ClearwaterAvailableActionTypes =
  | 'delete'
  | 'delete_and_ignore'
  | 'clear'
  | 'clear_and_update_post'
  | 'unclear'
  | 'adjustBy'
  | 'match'
  | 'unmatch'
  | 'editNote'
  | 'editTran'

export enum BulkCwTranUpdateActionType {
  DELETE = 'DELETE',
  DELETE_AND_IGNORE = 'DELETE_AND_IGNORE',
  CLEAR = 'CLEAR',
  CLEAR_AND_UPDATE_POST = 'CLEAR_AND_UPDATE_POST',
  UNCLEAR = 'UNCLEAR',
  DELETE_NOTES = 'DELETE_NOTE',
  EDIT_NOTES = 'EDIT_NOTE',
  DELETE_AND_HOLD = 'DELETE_AND_HOLD',
  EDIT_TRAN = 'EDIT_TRAN',
}

export interface ClearwaterTransactionsSetValues {
  tranTypeCodes: string[]
  secTypeCodes: string[]
  currencyCodes: string[]
  userNames: string[]
  linkedStatus: LinkedStatus[]
}

export interface ClearwaterTransactionsFilterContext {
  filterContext: {
    onlyCleared?: boolean
    extDataSourceType?: ExtDataSourceType
  }
}

export interface ClearwaterTransactionsAdvancedOptions {
  clearFiltersOnNewAccountLoad: boolean
  showErrorIcons: boolean
  sortByAbsolute: boolean
}

export type ExtDataSourceType = 'Custody' | 'Trading'

export interface TransactionData {
  transactionId: string
  originalId: number
  userId: number
  accountId: number
}

export interface Transactions {
  transactionData: TransactionData
  metaData: Record<string, unknown>
}

export enum BulkCwTranNoteCommandType {
  EDIT_NOTE = 'EDIT_TRANSACTION_NOTE',
  DELETE_NOTE = 'DELETE_TRANSACTION_NOTE',
}
